const doneServicesOutput = {
  title: `Servicios concluidos`,
};

export default doneServicesOutput;
